class AccountSettings.Hashtag extends Backbone.Model
  urlRoot: '/keepcon/hashtag_searches'

  initialize:(hashtag)->

  renovationType:->
    @get('renovation_type')

  isAutomaticRenewal: ->
    @get('renovation_type') == 'automatic-renewal'

  runDate:->
    @get('run_date')

  expirationDate:->
    @get('expiration_date')

  endpointSelected:->
    @get('listening_endpoint')

  renovationType:->
    @get('renovation_type')

  sourceId:->
    @get('source_id')

  name:->
    @get('hashtag_name')

  status:->
    @get('status')

  changeRenovationType:(renovationType)->
    @set('renovation_type', renovationType)
    @save()

  changeListeningEndpoint:(listeningEndpoint)->
    @set('listening_endpoint', listeningEndpoint)
    @save()

  changeStatus:(status)->
    @set('status', status)
    @save()

  remove:->
    @destroy(success:=> (@notifyDestroy()))

  notifyDestroy:=>
    @trigger('hashtag:destroy:success')
